export default __webpack_public_path__ + "static/media/profile.da970b88.svg";